<template>
  <app-layout>
    <template #header>
      <div class="flex items-center">
        <div class="flex-1">
          <h1 class="text-lg">
            Companies
          </h1>
        </div>
        <div class="ml-6 self-center">
          <a
            :href="route('home')"
            class="transition-all transition-normal inline-flex items-center px-4 py-3 border-2 border-grey-300 text-grey-800 shadow text-sm font-semibold bg-white hover:bg-gray-50 focus:outline-none focus:shadow-outline no-underline hover:bg-primary-100 hover:border-primary-300 leading-none"
          >
            Dashboard
          </a>
        </div>
      </div>
    </template>
    <div class="container max-w-lg mt-12">
      <div class="profile flex justify-between items-baseline border-b pb-4">
        <h2>
          {{ companies.length }} companies
          <small
            v-if="isFiltered"
            class="text-xs inline-block bg-primary-200 text-primary-900 font-normal italic px-2 align-text-top"
          >
            Filtered: {{ filteredCompanies.length }}
          </small>
        </h2>
        <input
          v-model="filter"
          placeholder="Search companies"
          type="search"
          class="px-4 py-2 bg-transparent focus:bg-white outline-none transition-all transition-normal"
        />
      </div>
      <ul
        v-if="totalCompanies > 0"
        class="list-reset bg-white px-8 py-4 shadow-lg"
      >
        <li
          v-for="(company, index) in filteredCompanies"
          :key="company.id"
          class="flex border-b pb-4 pt-4"
          :class="index == filteredCompanies.length - 1 ? 'border-transparent' : 'border-grey-300'"
        >
          <div>
            <p>
              <a
                :href="route('companies.view', company.id)"
                class="font-bold"
              >{{ company.name | sentencecase }}</a>
              <span
                v-if="!company.users_count"
                class="italic text-negative-500 text-xs"
              >
                No users assigned
              </span>
            </p>
            <p>
              <small>Number of users: {{ company.users_count }}</small>
            </p>
          </div>
        </li>
      </ul>
      <div
        v-else
        class="flex h-64 items-center justify-center flex-col"
      >
        <icon
          icon="important"
          class="w-24 h-24 icons-primary"
        />
        <template v-if="isFiltered">
          <h3>No Results Found</h3>
        </template>
        <template v-else>
          <h3>There are no companies available</h3>
        </template>
      </div>
      <div
        v-if="totalCompanies > 0"
        class="flex mt-4 justify-center items-center"
      >
        <div class="w-32">
          <icon-link
            v-if="!firstPage"
            icon="cheveron-left-circle"
            href="#"
            @click.prevent="prevPage"
          >
            Previous
          </icon-link>
        </div>
        <div class="text-center px-4 text-sm font-bold w-32">
          {{ pageNumber }}/{{ totalPages }}
        </div>
        <div class="w-32 text-right">
          <icon-link
            v-if="!lastPage"
            icon="cheveron-right-circle"
            icon-placement="right"
            href="#"
            @click.prevent="nextPage"
          >
            Next
          </icon-link>
        </div>
      </div>
    </div>
  </app-layout>
</template>

<script>
import Fuse from "fuse.js";
export default {
  name: "Companies",
  data() {
    return {
      pageNumber: 1,
      paginationAmount: 8,
      filter: ""
    };
  },
  computed: {
    companies() {
      return this.state.companies;
    },
    isFiltered() {
      return this.filter !== "" && this.filter !== null;
    },
    filteredCompanies() {
      const end = this.paginationAmount * this.pageNumber;
      const start = end - this.paginationAmount;
      if (!this.isFiltered) return this.companies.slice(start, end);
      return this.searchResults.slice(start, end);
    },
    searchResults() {
      const options = {
        shouldSort: true,
        tokenize: true,
        threshold: 0.4,
        location: 0,
        distance: 5,
        maxPatternLength: 32,
        minMatchCharLength: 1,
        keys: ["name", "email", "company.name"]
      };
      const results = new Fuse(this.companies, options);
      return results.search(this.filter);
    },
    firstPage() {
      return this.pageNumber === 1;
    },
    lastPage() {
      return this.pageNumber === this.totalPages;
    },
    totalPages() {
      return Math.ceil(this.totalCompanies / this.paginationAmount);
    },
    totalCompanies() {
      return this.isFiltered
        ? this.filteredCompanies.length
        : this.companies.length;
    }
  },
  created() {
    document.title = `Gateway companies :: ${document.title}`;
  },
  methods: {
    prevPage() {
      if (this.firstPage) return;
      return this.pageNumber--;
    },
    nextPage() {
      if (this.lastPage) return;
      return this.pageNumber++;
    }
  }
};
</script>
